/**
 * A ready-made question for the contact form, split so the greeting and the sign-off can be kept
 * out of the way when several questions end up in the same message
 */
export type PrefilledMessage = {
  /** Opening line, only used when the buyer has not written anything yet */
  greeting: string;
  /** The question itself, which is what gets appended to an existing draft */
  question: string;
  /** Closing line, kept at the bottom of the message and never repeated */
  signoff: string;
};

/** Takes the sign-off off the end of a draft, so the next question can be added underneath it */
const withoutSignoff = (draft: string, signoff: string): string =>
  draft.endsWith(signoff) ? draft.slice(0, -signoff.length).trimEnd() : draft;

/**
 * Adds a prefilled message to whatever the buyer has already written
 */
export const withPrefilledMessage = (currentMessage: string, prefilledMessage: PrefilledMessage): string => {
  const { greeting, signoff } = prefilledMessage;
  const draft = currentMessage.trim();
  const question = prefilledMessage.question.trim();

  if (draft.includes(question)) {
    return currentMessage;
  }
  const body = draft.length === 0 ? `${greeting} ${question}` : `${withoutSignoff(draft, signoff)} ${question}`;
  return `${body} ${signoff}`;
};
